<template>
  <div class="footercontainer">
    <footer class="footer strangefooter">
      <div class="container">
        <div class="footer-main">
          <div class="footer-header">
            <i class="logo logo-left icon icon-logo-kn"></i>
          </div>
          <div class="footer-nav">
            <dl class="column-list column-th">
              <dt>
                <p>
                  <a
                    href="/vehicles/"
                    code-ga="event, C02_everypage, 底部导航-购车相关, C02A04L04_everypage_底部导航-购车相关_全系车型"
                    code-stm="event, 底部通栏, 全系车型"
                    >全系车型</a
                  >
                </p>
                <p>
                  <a
                    href="/shop-made-easy/"
                    code-ga="event, C02_everypage, 底部导航-购车相关, C02A04L05_everypage_底部导航-购车相关_购车指南"
                    code-stm="event, 底部通栏, 购车指南"
                    >购车指南</a
                  >
                </p>
                <p>
                  <a
                    href="/promotions/"
                    code-ga="event, C02_everypage, 底部导航-购车相关, C02A04L06_everypage_底部导航-购车相关_市场活动"
                    code-stm="event, 底部通栏, 市场活动"
                    >市场活动</a
                  >
                </p>
                <p>
                  <a
                    href="/owners/"
                    code-ga="event, C02_everypage, 底部导航-购车相关, C02A04L07_everypage_底部导航-购车相关_车主服务"
                    code-stm="event, 底部通栏, 车主服务"
                    >车主服务</a
                  >
                </p>
                <p>
                  <a
                    href="/test-drive/"
                    code-ga="event, C02_everypage, 底部导航-购车相关, C02A04L08_everypage_底部导航-购车相关_预约试驾"
                    code-stm="event, 底部通栏, 预约试驾"
                    >预约试驾</a
                  >
                </p>
                <p>
                  <a
                    href="/dealer/"
                    code-ga="event, C02_everypage, 底部导航-购车相关, C02A04L09_everypage_底部导航-购车相关_经销商查询"
                    code-stm="event, 底部通栏, 经销商查询"
                    >经销商查询</a
                  >
                </p>
              </dt>
            </dl>
            <dl class="column-list">
              <dt>
                品牌<span><i class="icon icon-down"></i></span>
              </dt>
              <dd>
                <p>
                  <a
                    href="/brand/brand-identity/"
                    code-ga="event, C02_everypage, 底部导航-品牌, C02A01L02_everypage_底部导航-品牌_关于我们"
                    code-stm="event, 底部通栏, 关于我们"
                    >关于我们</a
                  >
                </p>
                <p>
                  <a
                    href="/brand/csr/"
                    code-ga="event, C02_everypage, 底部导航-品牌, C02A01L03_everypage_底部导航-品牌_社会责任"
                    code-stm="event, 底部通栏, 社会责任"
                    >社会责任</a
                  >
                </p>
                <p>
                  <a
                    href="/brand/tech/index.html"
                    code-ga="event, C02_everypage, 底部导航-品牌, C02A01L04_everypage_底部导航-品牌_技术展厅"
                    code-stm="event, 底部通栏, 技术展厅"
                    >技术展厅</a
                  >
                </p>
                <p>
                  <a
                    href="/brand/videos/"
                    code-ga="event, C02_everypage, 底部导航-品牌, C02A01L05_everypage_底部导航-品牌_精彩视频"
                    code-stm="event, 底部通栏, 精彩视频"
                    >精彩视频</a
                  >
                </p>
                <p>
                  <a
                    href="/brand/news2/"
                    code-ga="event, C02_everypage, 底部导航-品牌, C02A01L06_everypage_底部导航-品牌_新闻"
                    code-stm="event, 底部通栏, 新闻"
                    >新闻</a
                  >
                </p>
              </dd>
            </dl>
            <dl class="column-list">
              <dt>
                服务信息<span><i class="icon icon-down"></i></span>
              </dt>
              <dd>
                <p>
                  <a
                    href="/owners/service-concept/"
                    code-ga="event, C02_everypage, 底部导航-服务信息, C02A02L01_everypage_底部导航-服务信息_服务理念"
                    code-stm="event, 底部通栏, 服务理念"
                    >服务理念</a
                  >
                </p>
                <p>
                  <a
                    href="/owners/environment-certification/"
                    code-ga="event, C02_everypage, 底部导航-服务信息, C02A02L03_everypage_底部导航-服务信息_环保认证信息查询"
                    code-stm="event, 底部通栏, 环保认证信息查询"
                    >环保认证信息查询</a
                  >
                </p>
                <p>
                  <a
                    target="_blank"
                    href="https://kcn.atsw.cn/cvtidykmc/common/main.do"
                    rel="nofollow"
                    code-ga="event, C02_everypage, 底部导航-服务信息, C02A02L04_everypage_底部导航-服务信息_维修技术信息公开"
                    code-stm="event, 底部通栏, 维修技术信息公开"
                    >维修技术信息公开</a
                  >
                </p>
              </dd>
            </dl>
            <dl class="column-list">
              <dt>
                走进我们<span><i class="icon icon-down"></i></span>
              </dt>
              <dd>
                <p>
                  <a
                    href="/dealersjoin/"
                    code-ga="event, C02_everypage, 底部导航-走进我们, C02A03L05_everypage_底部导航-走进我们_经销商加盟"
                    code-stm="event, 底部通栏, 经销商加盟"
                    >经销商加盟</a
                  >
                </p>
                <p>
                  <a
                    target="_blank"
                    href="https://www.vaatz.com/vsims/view/hksupp/KMC/index.html"
                    rel="nofollow"
                    code-ga="event, C02_everypage, 底部导航-走进我们, C02A03L07_everypage_底部导航-走进我们_供应商申请"
                    code-stm="event, 底部通栏, 供应商申请"
                    >供应商申请</a
                  >
                </p>
                <p>
                  <a
                    href="/brand/news4/"
                    code-ga="event, C02_everypage, 底部导航-公告, C02A03L07_everypage_底部导航-走进我们_公告"
                    code-stm="event, 底部通栏, 公告"
                    >公告</a
                  >
                </p>
                <p>
                  <a
                    target="_blank"
                    href="http://www.hyundai-hmtc.com"
                    rel="nofollow"
                    code-ga="event, C02_everypage, 底部导航-走进我们, C02A03L08_everypage_底部导航-走进我们_中国研发中心"
                    code-stm="event, 底部通栏, 中国研发中心"
                    >中国研发中心</a
                  >
                </p>
                <p>
                  <a
                    target="_blank"
                    href="/jobs/"
                    code-ga="event, C02_everypage, 底部导航-走进我们, C02A03L09_everypage_底部导航-走进我们_人才招聘"
                    code-stm="event, 底部通栏, 人才招聘"
                    >人才招聘</a
                  >
                </p>
                <p>
                  <a
                    target="_blank"
                    href="https://v2.live800.com/live800/chatClient/chatbox.jsp?companyID=399888&configID=124926&jid=9029641736&s=1"
                    rel="nofollow"
                    code-ga="event, C02_everypage, 底部导航-走进我们, C02A03L11_everypage_底部导航-走进我们_在线客服"
                    code-stm="event, 底部通栏, 在线客服"
                    >在线客服</a
                  >
                </p>
                <p>
                  <a
                    target="_blank"
                    href="/brand/policy/"
                    code-stm="event, 底部通栏, 隐私条款"
                    >隐私条款</a
                  >
                </p>
              </dd>
            </dl>
          </div>
          <div class="footer-link">
            <a
              layer-img-qr="/static/src/img/icon/alert-applet2.jpg"
              code-ga="event, C02_everypage, 底部导航-起亚自媒体平台, C02A05L04_everypage_底部导航-起亚自媒体平台_一起来亚小程序"
              code-stm="event, 底部通栏, 起亚自媒体平台_一起来亚小程序"
              ><i class="icon icon-applet"></i
            ></a>
            <a
              layer-img-qr="/static/src/img/icon/alert-wx.jpg"
              code-ga="event, C02_everypage, 底部导航-起亚自媒体平台, C02A05L05_everypage_底部导航-起亚自媒体平台_起亚官方服务号"
              code-stm="event, 底部通栏, 起亚自媒体平台_起亚官方服务号"
              ><i class="icon icon-weixin"></i
            ></a>
            <a
              target="_blank"
              href="https://weibo.com/dongfengyuedaqiya?nick=%E4%B8%9C%E9%A3%8E%E6%82%A6%E8%BE%BE%E8%B5%B7%E4%BA%9A"
              rel="nofollow"
              code-ga="event, C02_everypage, 底部导航-起亚自媒体平台, C02A05L06_everypage_底部导航-起亚自媒体平台_起亚微博"
              code-stm="event, 底部通栏, 起亚自媒体平台_起亚微博"
              ><i class="icon icon-weibo"></i
            ></a>
            <a
              target="_blank"
              href="https://dyk.tmall.com/?spm=a1z10.3-b.1997427721.d4918089.1cb7c2ebk3nYg1"
              rel="nofollow"
              code-ga="event, C02_everypage, 底部导航-起亚自媒体平台, C02A05L08_everypage_底部导航-起亚自媒体平台_起亚天猫旗舰店"
              code-stm="event, 底部通栏, 起亚自媒体平台_起亚天猫旗舰店"
              ><i class="icon icon-tianmao"></i
            ></a>
            <a href="/contact-us" code-stm="event, 底部通栏, 联系我们"
              ><i class="icon icon-contact"></i
            ></a>
            <a
              target="_blank"
              href="https://v2.live800.com/live800/chatClient/chatbox.jsp?companyID=399888&configID=124926&jid=9029641736&s=1"
              rel="nofollow"
              code-ga="event, C02_everypage, 底部导航-走进我们, C02A03L11_everypage_底部导航-走进我们_在线客服"
              code-stm="event, 底部通栏, 在线客服"
              ><i class="icon icon-zaixiankefu3"></i
            ></a>
          </div>
        </div>
      </div>
    </footer>
    <div class="footer-infos">
      <div class="container">
        <div class="breakcrumb">
          <a href="https://www.kia.cn"
            ><i class="icon icon-home"></i><span>首页</span></a
          >
          <i class="icon icon-right"></i>
          <span>全新起亚 灵感由你</span>
        </div>
        <div class="copyright">
          © 江苏悦达起亚汽车有限公司版权所有
          <a target="_blank" href="https://beian.miit.gov.cn" rel="nofollow"
            >苏ICP备11007590号-4</a
          >
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32099102000214"
            style="text-decoration: none"
            ><img src="../assets/images/beian.png" style="width: 20px" /><span
              >苏公网安备 32099102000214号</span
            ></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted: function () {
    this.footer();
  },
  methods: {
    footer: function () {
      if ($(".footer").length <= 0) return;

      const _this = this;

      // 展开或者折叠
      $(".footer .column-list dt span").click(function () {
        const parent = $(this).closest(".column-list");
        // const index = parent.index()
        if (parent.hasClass("open")) {
          parent.removeClass("open");
          parent.find("dd").slideUp(300, function () {
            // 动画结束后去除jquery中设置的display为none的属性
            $(this).removeAttr("style");
          });
        } else {
          parent.addClass("open");
          parent.find("dd").slideDown(300);
        }
      });

      // 分享弹出
      $(".footer-link a[layer-img]").click(function (e) {
        _this.Layer.qrImg($(this));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 767px) {
  .container {
    padding-right: 1.53rem;
    padding-left: 1.53rem;
  }
}
.strangefooter {
  margin-top: 0px;
}
</style>
